export const isProd =
  typeof process !== "undefined"
    ? process.env.NODE_ENV === "production"
    : NODE_ENV === "production";
export const isBrowser = typeof window !== "undefined";
